import { combineReducers } from 'redux';

import counter from './counter';
import todos from './todos';
import events from './events';
import notices from './notices';
import webLinks from './webLinks';
import comments from './comments';
import inviteds from './inviteds';
import userComments from './userComments';
import eventDates from './eventDates';

let reduce = combineReducers({
    counter: counter,
    todos: todos,
    events:events,
    notices: notices,
    webLinks: webLinks,
    comments: comments,
    inviteds: inviteds,
    userComments: userComments,
    eventDates: eventDates
})


export default reduce;

